// Infinite "Trusted by Industry Leaders" carousel — extracted from Home.tsx
// so other screens (the app's fan Browse tab) can reuse it. The motion —
// drift, endless loop, drag and fling, pause on hover and touch, Reduce
// Motion → a still row — is DriftRow's, shared with the homepage's Top Songs
// row. `interactive`: the landing page keeps clickable cards that link to
// each talent's public page; false renders the same carousel as a
// non-clickable showcase.
import React from "react";
import { Link } from "react-router-dom";
import DriftRow from "./DriftRow";

export const INDUSTRY_LEADERS = [
  { name: "Robby Dinero", img: "/RequestDJImages/robbydinero.jpg", slug: "dj-robby-dinero" },
  { name: "Bang Jackson", img: "/RequestDJImages/bangjackson.jpg", slug: "bang-jackson" },
  { name: "DJ Lucky", img: "/RequestDJImages/djlucky.jpg", slug: "dj-lucky" },
  { name: "DJ Frisco", img: "/RequestDJImages/djfrisco.jpg", slug: "frisco" },
  { name: "DJ Xoul", img: "/RequestDJImages/djxoul.jpg", slug: "dj-xoul" },
  { name: "DJ Donavon", img: "/RequestDJImages/djdonavon.jpg", slug: "donavon" },
  { name: "DJ Benofficial", img: "/RequestDJImages/djbenofficial.jpg", slug: "dj-benofficial" },
  { name: "DJ Lucha Libre", img: "/RequestDJImages/djluchalibre.jpg", slug: "lucha-libre" },
  { name: "DJ Sonny James", img: "/RequestDJImages/djsonnyjames.jpg", slug: "sonny-james" },
] as const;

interface Props {
  items?: readonly { name: string; img: string; slug: string }[];
  /** false = showcase mode: cards render as plain divs. */
  interactive?: boolean;
  /** Who opens a card (the talent's Discover, 1.5.3): the caller navigates
   *  instead of the link. Without it a card is a plain link to the page. */
  onOpen?: (slug: string) => void;
}

const IndustryCarousel: React.FC<Props> = ({ items = INDUSTRY_LEADERS, interactive = true, onOpen }) => (
  <DriftRow
    count={items.length}
    direction={1}
    renderSet={(copy, isRepeat) => {
      // Repeats are for the eye only: one tab stop and one read-out per talent.
      const repeat = isRepeat ? ({ "aria-hidden": true, tabIndex: -1 } as const) : {};
      return items.map((a) => {
        const inner = (
          <>
            <div className="ambassador-img-wrap">
              <img src={a.img} alt={isRepeat ? "" : a.name} className="ambassador-img ambassador-img--talent" loading="lazy" draggable={false} />
            </div>
            <span className="ambassador-name">{a.name}</span>
          </>
        );
        return interactive ? (
          <Link
            key={`${a.slug}-${copy}`}
            to={`/${a.slug}`}
            state={{ fromBrowse: true }}
            className="ambassador-card ambassador-card--link"
            onClick={
              onOpen
                ? (e) => {
                    e.preventDefault();
                    onOpen(a.slug);
                  }
                : undefined
            }
            {...repeat}
          >
            {inner}
          </Link>
        ) : (
          <div key={`${a.slug}-${copy}`} className="ambassador-card" aria-hidden={isRepeat || undefined}>
            {inner}
          </div>
        );
      });
    }}
  />
);

export default IndustryCarousel;
